import script from "./AddProductToCollections.vue?vue&type=script&setup=true&lang=js"
export * from "./AddProductToCollections.vue?vue&type=script&setup=true&lang=js"

import "./AddProductToCollections.vue?vue&type=style&index=0&id=73546494&lang=scss"

const __exports__ = script;

export default __exports__